<!-- eslint-disable -->
<script setup>
import { useDateTimeSportFiltersStore } from '@/stores/date_time_sport_filters';
import { useI18n } from 'vue-i18n';

const dateTimeSportFiltersStore = useDateTimeSportFiltersStore();
const { t } = useI18n();

const selectSort = (sort) => {
	dateTimeSportFiltersStore.sort = sort;
	dateTimeSportFiltersStore.expand_sort = false;
	document.body.classList.remove('filters-show');
}
</script>

<template>
	<ul class="date-list">
		<li :class="{ 'active-green-list': dateTimeSportFiltersStore.sort === 'default' }">
			<span class="label" @click="selectSort('default')">{{ $t('general.default') }}</span>
		</li>
		<li :class="{ 'active-green-list': dateTimeSportFiltersStore.sort === 'time' }">
			<span class="label" @click="selectSort('time')">{{ $t('general.time') }}</span>
		</li>
	</ul>
</template>
<style scoped>
	.date-list {
		list-style: none;
		padding: 0;
		margin: 0;
	}

	.date-list li {
		padding: 12px 15px;
		border-bottom: 1px solid var(--tab-gray);
		display: flex;
		gap: 5px;
		font-size: 14px;
		cursor: pointer;
	}

	.date-list li .count { color: var(--light-gray); font-size: 12px; }

	.date-list li.active-green-list {
		color: var(--primary);
	}

	.time-btn.active-green {
		color: var(--white) !important;
		background: var(--primary);
		border: 1px solid var(--primary);
		font-weight: bold;
	}

	.divider { border: 0; border-top: 1px solid var(--tab-gray); margin: 15px 15px; }

	/* Grid for buttons */
	.time-grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 8px;
		padding: 12px 15px;
	}

	.time-btn {
		background: transparent;
		border: 1px solid var(--tab-gray);
		color: var(--white);
		padding: 8px 3px;
		border-radius: 6px;
		font-size: 11px;
		cursor: pointer;
		text-align: center;
	}

	.btn-count { color: var(--light-gray); }

	.time-btn:hover {
		color: var(--white);
		border: 1px solid var(--primary);
		background: var(--primary);
	}
</style>